/* unplugin-vue-components disabled */import { render } from "./form-page.vue?vue&type=template&id=5ab5c285&scoped=true"
import script from "./form-page.vue?vue&type=script&lang=js"
export * from "./form-page.vue?vue&type=script&lang=js"

import "./form-page.vue?vue&type=style&index=0&id=5ab5c285&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/e-bike/e-bike-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab5c285"]])

export default __exports__